<template>
  <div class="pp">
    <div class="text-center">
      <div class="h-w-150px bg-primary mx-auto rounded-full">
        <img src="" alt="" class="" />
      </div>
      <p class="w-full font-semibold text-black fsize18 mb-4 mt-6">
        File type should be jpg/jpeg/png/pdf
      </p>
    </div>
    <div class="w-full gap-4 flex justify-center">
      <vs-button color="primary" @click="centerDialogVisible1 = false"
        >Okay</vs-button
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.pp .el-dialog__header {
  background-color: white !important;
}
.h-w-150px {
  width: 150px;
  height: 150px;
}
</style>
